import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import {
  getPreView,
  getPdfPreView,
  archiveTaskApi, fetchTaskById,
} from '../../api/task';
import '../../css/forms/default-forms.css';
import hasAccess from "../../helpers/permissionChecker";

export class DashboardPreView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmArchive: false,
    };

    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
    this.close = this.close.bind(this);
    this.archive = this.archive.bind(this);
    this.print = this.print.bind(this);
    this.confirmArchive = this.confirmArchive.bind(this);
    this.cancelArchive = this.cancelArchive.bind(this);
  }

  componentWillMount() {
    this.fetchDataRouteById();
  }

  componentDidMount() {
    if (document.querySelector('#financial-info-wrapper')) {
      document.querySelector('#financial-info-wrapper').remove();
    }
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.getPreViewHtml(id);
    this.props.getDataById(id);
  }

  close() {
    this.props.backToDashboard();
  }

  confirmArchive() {
    this.setState({
      confirmArchive: !this.state.confirmArchive,
    });
  }

  cancelArchive() {
    this.setState({
      confirmArchive: false,
    });
  }

  archive() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.archiveThis(id);
  }

  print() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.downloadPdf(id);
  }

  render() {
    const breadCrumbs = document.referrer.match("calendar") ?
      [
        { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
        { url: document.referrer, icon: 'perm_contact_calendar', name: 'Calendar' },
        { icon: 'info', name: 'Task Info' }
      ] :
      [
        { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
        { url: '/pages/customers', icon: 'account_circle', name: 'Customers' },
        { icon: 'info', name: 'Task Info' }
      ];
    const taskPreVire = path(['tasks', 'html'], this.props);
    const authorId = path(['tasks', 'current', 'user_id'], this.props);
    return (
      <div style={{ paddingBottom: '20px' }}>
        <Breadcrumbs list={breadCrumbs}/>
        <div dangerouslySetInnerHTML={{ __html: taskPreVire }}></div>
        <div className="row">
          {this.state.confirmArchive && <div
            className="col-12"
            style={{
              padding: '10px',
            }}
          >
            <div className="col-12">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" style={{ marginRight: '8px' }}
                      onClick={this.cancelArchive}>
                <span className="color-default">No</span>
              </button>
              <button className="btn btn-rounded btn-icon ui-btn pull-right" style={{ marginRight: '8px' }}
                      onClick={this.archive}>
                <span className="color-default">Yes</span>
              </button>
            </div>
            <div
              className="col-12"
              style={{
                'position': 'relative',
                'right': '19px',
                'top': '5px',
              }}
            >
              <p className="pull-right">Are you sure you want to Archive this work order?</p>
            </div>
          </div>}
          <div className="col-12">
            {hasAccess({ 'permAreaKey': 'workOrder', 'permTypeKey': 'archive', 'idForCheckingAuthor': authorId }) &&
            <button className="btn btn-rounded btn-icon ui-btn pull-right" style={{ marginRight: '8px' }}
                    onClick={this.confirmArchive}>
              <span className="color-default">Archive</span>
            </button>
            }
            <button id="view-print-btn" className="btn btn-rounded btn-icon ui-btn pull-right"
                    style={{ marginRight: '8px' }} onClick={this.print}>
              <span className="color-default">Print</span>
            </button>
            <button className="btn btn-rounded btn-icon ui-btn pull-right" style={{ marginRight: '8px' }}
                    onClick={this.close}>
              <span className="color-default">Close</span>
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchTaskById(id)(dispatch);
    },
    getPreViewHtml: (id) => {
      getPreView(id)(dispatch);
    },
    backToDashboard: () => {
      dispatch(push('/pages/dashboards'));
    },
    downloadPdf: (id) => {
      getPdfPreView(id)(dispatch);
    },
    archiveThis: (id) => {
      archiveTaskApi(id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPreView);



// WEBPACK FOOTER //
// ./src/containers/DashboardPreView/index.js